<div class="flex flex-col bg-card overflow-hidden height-100p">
  <div
    class="pl-3 pr-3 pt-2 pb-2 border-b flex items-center"
    appAccountColorBackground
    #backgroundDirective="appAccountColorBackground"
    [colorName]="panelDef?.color"
  >
    <div class="flex items-center flex-auto" *ngIf="changeTitleMode">
      <app-form-field [fieldDef]="titleFieldDef" [model]="project" (onUpdate)="update($event)"></app-form-field>
    </div>
    <div class="flex flex-col">
      <div
        *ngIf="!changeTitleMode"
        class="font-bold text-md text-secondary uppercase tracking-wider"
        [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
      >
        {{ panelDef.title }}
      </div>
    </div>
    <div class="ml-auto">
      <button
        *ngIf="!readonly && !changeTitleMode"
        mat-icon-button
        [matTooltip]="'Add'"
        (click)="add()"
        [appAuthorize]="canEditDeal()"
        denyAction="disable"
      >
        <mat-icon
          [svgIcon]="'add'"
          [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
        ></mat-icon>
      </button>

      <ng-container *ngIf="canEditPanelDef">
        <button mat-icon-button type="button" *ngIf="!(editMode || changeTitleMode)" [matMenuTriggerFor]="listCardMenu">
          <mat-icon
            class="icon-size-20"
            [svgIcon]="'more_vert'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <mat-menu #listCardMenu="matMenu">
          <button mat-menu-item (click)="toggleChangeTitleMode()" type="button">
            <mat-icon [svgIcon]="'edit'"></mat-icon>
            Change Panel Heading
          </button>
          <button mat-menu-item [matMenuTriggerFor]="toggleLabelMenu" type="button">
            <mat-icon [svgIcon]="'color_lens'"></mat-icon>
            Heading Color
          </button>
          <mat-menu class="mailbox-details-toggle-label-menu-panel" #toggleLabelMenu="matMenu">
            <div
              mat-menu-item
              class="gap-2"
              *ngFor="let color of accountColors$ | async"
              (click)="selectHeaderColor(color.name)"
            >
              <ts-color-bubble [hexColor]="color.hex_value"></ts-color-bubble>
              {{ color.label }}
            </div>
          </mat-menu>
        </mat-menu>
        <button
          class="cancel-button"
          mat-icon-button
          type="button"
          *ngIf="editMode || changeTitleMode"
          [matTooltip]="'Cancel'"
          (click)="toggleEditMode(false)"
        >
          <mat-icon
            [svgIcon]="'cancel'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
        <button mat-icon-button *ngIf="changeTitleMode" type="submit" (click)="saveLayout()" [matTooltip]="'Save'">
          <mat-icon
            [svgIcon]="'save'"
            [ngClass]="backgroundDirective.isContrastLight ? 'text-white' : 'text-secondary'"
          ></mat-icon>
        </button>
      </ng-container>
    </div>
  </div>

  @if (ui.isLoading) {
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  }

  <div class="dates-container height-100p">
    @if (!ui.isLoading && !keyDates.length) {
      <div class="flex flex-col items-center justify-center h-full">
        <mat-icon class="icon-size-40" [svgIcon]="'event_busy'"></mat-icon>
        <p class="text-2xl text-secondary font-medium mt-4 p-0">No records found</p>
        <p class="text-sm text-secondary mt-2 p-0" [appAuthorize]="canEditDeal()">
          Add Key Dates to this panel by clicking in the
          <mat-icon class="icon-size-14" [svgIcon]="'add'"></mat-icon>
          button above.
        </p>
      </div>
    } @else {
      <form class="dates-container__form" [formGroup]="keyDatesForm">
        <ng-container formArrayName="keyDates">
          <ng-container *ngFor="let keyDateForm of keyDates.controls; let i = index">
            <div class="dates-container__form__item" [formGroup]="keyDateForm">
              <mat-form-field>
                <input matInput formControlName="label" placeholder="Label" (blur)="save(i)" [spellcheck]="false" />
              </mat-form-field>
              <mat-form-field>
                <input
                  matInput
                  [matDatepicker]="startDatePicker"
                  readonly
                  formControlName="date"
                  placeholder="Date"
                  [ngClass]="getOverdueClass(i)"
                  (dateChange)="save(i)"
                />
                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                <mat-datepicker #startDatePicker></mat-datepicker>
              </mat-form-field>
              <div class="dates-container__form__item__inline-actions">
                <button
                  type="button"
                  mat-icon-button
                  matTooltip="Remove"
                  (click)="remove(i)"
                  [appAuthorize]="canEditDeal()"
                >
                  <mat-icon svgIcon="cancel"></mat-icon>
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </form>
    }
  </div>
</div>
